export const DATE_FORMAT = 'DD-MM-YYYY';

export const status_colors: { [key: string]: string } = {
  issued: '#87A330',
  cancelled: '#D6222A',
  request_created: '#E59500',
  checkout: '#002A4D99',
  report: '#002A4D99',
  updated: '#002A4D',
  documents: '#E5950099',
  cancel_expected: '#D6222A99',
  active: '#87a330',
  passive: '#d6222a',
  endorsement_request: '#002a4d99',
  rejected: '#C0392B',
  paid: '#28A745',
  file_opened: '#87A330',
};
